import {useTranslation} from "next-i18next"
import Image from "next/image"
import Link from "next/link"
import React, {useContext} from "react"
import LayoutContext from "../../context/LayoutContext"
import Typography from "../reusable/Typography/Typography"
import OrganizationContext from "../../context/OrganizationContext"
import DataContext from "../../context/DataContext"

const NavBarCheckoutPage2 = () => {
	const {organizationSlug, organizationData} = useContext(OrganizationContext)
	const {pageProps} = useContext(DataContext)

	const {t} = useTranslation()
	const {isMobile} = useContext(LayoutContext)
	return (<div style={{zIndex: 10000, top: 0}}
		className="sticky-top bg-white shadow-sm pt-3 pt-md-4 py-md-4">
		<div className="container">
			<div className="row justify-content-center justify-content-md-between  align-items-center">
				<div className="col-12 col-md-auto mb-2 mb-md-0">
					<div className="row gap-3 justify-content-center align-items-start">
						<div className="col-auto mb-1 mb-md-0">
							<Link href={"/"}
								as={"/"}>
								<img className="pointer"
									style={{maxWidth: `${isMobile ? "135px" : ""}`}}
									src={"/assets/logo-dark.svg"}
									alt="MyBikePlan Logo White"/>
							</Link>
						</div>
						{!isMobile && (!process.env.NEXT_PUBLIC_CUSTOM_INSTANCE || organizationData.hideCustomLogos) ? <div className="col-auto d-flex align-items-center">
							<Image src={"/assets/icons/checkout/lock.svg"}
								width={20}
								height={20}/>
							<Typography className="ms-2"
								variant="heading3"
								semanticTag="span">{t("secure-checkout")}</Typography>
						</div> : process.env.NEXT_PUBLIC_CUSTOM_INSTANCE && organizationSlug && <img src={organizationData?.companyIcon}
							style={{height: "25px", width: "auto"}}/>}
					</div>
				</div>
				<div className="col-12 col-md-auto d-flex flex-md-column justify-content-between align-items-end mb-3 m-md-0">
					<div>
						<Link href={"mailto:sales@mybikeplan.ch"}
							passHref={true}>
							<a className={`${isMobile ? "text-decoration-none" : ""}`}>
								<Typography className={`${isMobile ? "text-dark" : ""}`}
									variant="bodyLg"
									semanticTag="span">
									{t("sales@mybikeplan.ch")}
								</Typography>
							</a>
						</Link>
					</div></div>
			</div>
		</div>
	</div>
	)
}

export default NavBarCheckoutPage2
